import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import api from "@/lib/api";
import { installOffline } from "@/lib/offlineSync";
import { installUiSounds } from "@/lib/uiSounds";

// SafeGuard: registrazioni senza connessione e sincronizzazione automatica.
installOffline(api);
// Suoni dell'interfaccia (tocco, conferma, avviso).
installUiSounds();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: registra il service worker (app installabile)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
